/** Agentordinary chat only displays deliberate conversational content.
 * Automated runtime work_update records belong in Live Work / recorded activity. */
export type AgentChatStoredRow={
 id:string;sender_type:'owner'|'agent'|'system'|'external';sender_agent_id?:string|null;
 source_system?:string|null;content:unknown;created_at:string;
};
const obj=(v:unknown):Record<string,unknown>=>v&&typeof v==='object'&&!Array.isArray(v)?v as Record<string,unknown>:{};
const nonempty=(v:unknown):string=>typeof v==='string'?v.trim():'';
export function isAutomatedWorkUpdate(row:Pick<AgentChatStoredRow,'source_system'|'content'>):boolean{
 const item=obj(row.content);
 return row.source_system==='agentopia-task-state'||item.type==='work_update';
}
export function readableConversationText(content:unknown):string{
 if(typeof content==='string')return content.trim();
 const item=obj(content);
 // No synthetic agent replies: a summary is not a chat response.
 return nonempty(item.text)||nonempty(item.message);
}
export function presentConversationRows(rows:AgentChatStoredRow[]){
 return rows.filter(row=>!isAutomatedWorkUpdate(row)).map(row=>{
   const content=readableConversationText(row.content);
   const fields=obj(row.content);
   return {
    id:row.id,sender_type:row.sender_type,sender_agent_id:row.sender_agent_id,
    content,created_at:row.created_at,
    attachments:Array.isArray(fields.attachments)?fields.attachments.filter(a=>{
      const f=obj(a);return nonempty(f.name)&&nonempty(f.type);
    }).map(a=>({name:String(obj(a).name),type:String(obj(a).type)})):[]
   };
 }).filter(row=>Boolean(row.content));
}
export function workActivityText(content:unknown):{title:string;detail:string;status:string;taskId:string}|null{
 const item=obj(content);
 if(item.type!=='work_update')return null;
 const title=nonempty(item.title);
 const summary=nonempty(item.summary);
 const action=nonempty(item.next_action);
 const status=nonempty(item.status);
 if(!title&&!summary)return null;
 // Avoid reprinting generic "working..." chatter as work completed.
 if(status==='working')return null;
 return {
  title:title||'Agent work update',
  detail:summary+(action&&!/continue through agentopia qc and routing/i.test(action)?'\nNext: '+action:''),
  status:status||'update',taskId:nonempty(item.task_id)
 };
}
